var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73625 1.30849C6.09552 1.28749 6.2752 1.73552 6.00097 1.9686C5.36521 2.50892 4.99219 3.29792 4.99219 4.14844C4.99219 5.72762 6.27238 7.00781 7.85156 7.00781C8.70207 7.00781 9.49107 6.63478 10.0314 5.99901C10.2642 5.72506 10.7119 5.90407 10.6916 6.26304C10.5516 8.74011 8.49775 10.6875 6.00586 10.6875C3.41379 10.6875 1.3125 8.58621 1.3125 5.99414C1.3125 3.51691 3.23774 1.47042 5.69763 1.31075L5.70005 1.3106L5.73625 1.30849ZM4.78535 2.24306L4.73716 2.25902C3.17695 2.78839 2.0625 4.2667 2.0625 5.99414C2.0625 8.172 3.828 9.9375 6.00586 9.9375C7.74352 9.9375 9.22779 8.81025 9.74945 7.23738L9.75677 7.21472L9.75549 7.21555C9.20259 7.55927 8.5587 7.75174 7.88373 7.75766L7.85156 7.75781C5.85816 7.75781 4.24219 6.14184 4.24219 4.14844C4.24219 3.46178 4.43527 2.80617 4.78445 2.24453L4.78535 2.24306Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.fadfbc112b971a752f0b6e4012065408.svg";
export { ForwardRef as ReactComponent };